const scoreBarColor = (value) => {
  if (value >= 80) return 'var(--color-success)';
  if (value >= 60) return 'var(--color-warning)';
  return 'var(--color-error)';
};

export default scoreBarColor;
